import { ColumnType } from '@datachain/ui-sdk/components/dc-types';

import { MetadataTypeBE } from '../requesters/core/models/metadata.model';

export type CharacteristicType = {
	id: number;
	value: ColumnType;
	label: string;
};

export type DcTimestampFormat = { label: string; value: string };

export const AvailableNumberFormats: Array<{ code: string; lib: string }> = [
	{
		code: '##.##',
		lib: '##.##',
	},
	{
		code: '##,##',
		lib: '##,##',
	},
];

export const DefaultDateFormat = 'ISO 8601';
export const DefaultNumberFormat = '##,##';
export const DefaultTimezone = 'Europe/Paris';

export enum DcCoreElementType {
	CONNECTOR = 'CONNECTOR',
	DATASOURCE = 'DATASOURCE',
	ENTITY = 'ENTITETYPE',
	DATABLOCK = 'DATABLOCK',
	DASHBOARD = 'DASHBOARD',
	DEPOT = 'DEPOT',
	MAP = 'MAP',
	CHART = 'CHART',
	TIMELINE = 'TIMELINE',
	GRID = 'GRID',
	MEDIA = 'MEDIA',
	EXPORT_TEMPLATE = 'EXPORT_TEMPLATE',
	EXPOSITION = 'EXPOSITION',
	COLUMN = 'COLUMN',
	RANKING = 'RANKING',
	UNKNOWN = 'UNKNOWN',
}

export const DcCoreElementTypesMapping: Record<
	MetadataTypeBE,
	DcCoreElementType
> = {
	[MetadataTypeBE.Connector]: DcCoreElementType.CONNECTOR,
	[MetadataTypeBE.Datasource]: DcCoreElementType.DATASOURCE,
	[MetadataTypeBE.Entity]: DcCoreElementType.ENTITY,
	[MetadataTypeBE.Caracteristique]: DcCoreElementType.ENTITY,
	[MetadataTypeBE.Datablock]: DcCoreElementType.DATABLOCK,
	[MetadataTypeBE.Dashboard]: DcCoreElementType.DASHBOARD,
	[MetadataTypeBE.Depot]: DcCoreElementType.DEPOT,
	[MetadataTypeBE.Map]: DcCoreElementType.MAP,
	[MetadataTypeBE.Timeline]: DcCoreElementType.TIMELINE,
	[MetadataTypeBE.Chart]: DcCoreElementType.CHART,
	[MetadataTypeBE.Media]: DcCoreElementType.MEDIA,
	[MetadataTypeBE.Grid]: DcCoreElementType.GRID,
	[MetadataTypeBE.ExportTemplate]: DcCoreElementType.EXPORT_TEMPLATE,
	[MetadataTypeBE.Exposition]: DcCoreElementType.EXPOSITION,
	[MetadataTypeBE.Column]: DcCoreElementType.COLUMN,
	[MetadataTypeBE.Ranking]: DcCoreElementType.RANKING,
	[MetadataTypeBE.Default]: DcCoreElementType.UNKNOWN,
};

export enum SimpleType {
	DATASOURCE = 'DATASOURCE',
	ENTITY = 'ENTITY',
	DATABLOCK = 'DATABLOCK',
	DASHBOARD = 'DASHBOARD',
	MAP = 'MAP',
	TIMELINE = 'TIMELINE',
	MEDIA = 'MEDIA',
	EXPORT_TEMPLATE = 'EXPORT_TEMPLATE',
	EXPOSITION = 'EXPOSITION',
	COLUMN = 'COLUMN',
	RANKING = 'RANKING',
}

export enum ChartSubType {
	Indicator = 'indicator',
	BarLine = 'barline',
	Pie = 'pie',
	Funnel = 'funnel',
	LinearGauge = 'gauge_linear',
	CircularGauge = 'gauge_circular',
	BarGauge = 'gauge_bar',
	TreeMap = 'treemap',
	Sankey = 'sankey',
	Scatter = 'scatter',
	Range = 'range',
}

export enum GridSubType {
	Simple = 'simple',
	Pivot = 'pivot',
}

export enum ConnectorSubType {
	HDFS = 'HDFS',
	SFTP = 'SFTP',
	S3 = 'S3',
	SQL = 'SQL',
	HTTP = 'HTTP',
}

export enum DepotSubType {
	Parquet = 'PARQUET',
	Json = 'JSON',
	Csv = 'CSV',
	Excel = 'EXCEL',
	Binary = 'BINARY',
	Xml = 'XML',
}

export enum DepotTypes {
	SQL = 'SQL',
	MONGODB = 'MONGODB',
	CSV = 'CSV',
	PARQUET = 'PARQUET',
	EXCEL = 'EXCEL',
	BINARY = 'BINARY',
	JSON = 'JSON',
	JSON_V2 = 'JSON_V2',
	XML = 'XML',
	XML_V2 = 'XML_V2',
	TRINO = 'TRINO',
	NEO4J = 'NEO4J',
}
